/**
 * Background ↔ sidepanel / content script / service worker message `action` strings
 * for SharePoint Excel load building. Single source of truth for Vulcan and Alexandria.
 */

/** Side panel → SW: read cached EWA-parsed SharePoint Agile rows for a host tab. */
export const GetSharepointDataAction = 'getSharepointData';

/** SW → extension pages: Agile row cache updated after prefetch intercept or refresh. */
export const SharepointDataUpdatedAction = 'sharepointDataUpdated';

/** Content script → SW when Excel prefetch/sheet data is intercepted. */
export const SharepointSheetDataInterceptedAction =
  'sharepointSheetDataIntercepted';

/** Ask background to inject Excel prefetch hook in the current tab (avoids CSP). */
export const InjectExcelSheetInterceptorAction = 'injectExcelSheetInterceptor';

/** Side panel → SW: last EWA active sheet metadata for a tab (from Excel prefetch intercept). */
export const GetSharepointWorkbookContextAction =
  'getSharepointWorkbookContext';

/** Side panel → SW: list worksheet tab labels from Excel Online DOM (all frames). */
export const GetSharepointSheetTabTitlesAction = 'getSharepointSheetTabTitles';

/**
 * Injected Excel iframe observer → service worker (sheet tab strip DOM changed).
 * Passed into `installDrumkitExcelSheetTabObserver` via `executeScript` args (isolated world).
 */
export const SharepointExcelActiveSheetChangedAction =
  'sharepointExcelActiveSheetChanged';

/** Injected sheet-tab observer failed; isolated script → SW for Sentry. */
export const SharepointExcelSheetTabObserverErrorAction =
  'sharepointExcelSheetTabObserverError';

/**
 * Service worker → extension pages: notify side panel to refetch / swap cached rows.
 */
export const SharepointActiveSheetChangedBroadcastAction =
  'sharepointActiveSheetChangedBroadcast';

/**
 * SW → extension pages: Excel prefetch intercept fired for this tab (cells/workbook may have changed).
 * Turvo Graph provider listens to invalidate worksheet cache and re-fetch load-suggestions.
 */
export const SharepointExcelPrefetchInterceptBroadcastAction =
  'sharepointExcelPrefetchInterceptBroadcast';

/** Ask background to tell the tab's content script to re-read the Excel sheet (new rows). */
export const RequestRefreshSharepointSheetDataAction =
  'requestRefreshSharepointSheetData';

/** Side panel → SW → content script: snapshot of why SharePoint rows are/aren't loading. */
export const GetSharepointPipelineDebugAction = 'getSharepointPipelineDebug';
